import { useEffect, useState } from "react";
import { tickerNews } from "@/mocks/news";

const navLinks = [
  { label: "实时现场", href: "#live" },
  { label: "栏目速递", href: "#channels" },
  { label: "在场目击", href: "#onsite" },
  { label: "现场热榜", href: "#hot" },
  { label: "编辑部精选", href: "#picks" },
  { label: "关于我们", href: "#report" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header id="top" className="fixed inset-x-0 top-0 z-50">
      {/* breaking ticker */}
      <div className="flex items-center bg-foreground-900 text-background-50">
        <div className="flex items-center gap-2 shrink-0 px-3 md:px-4 py-1.5 bg-primary-500">
          <span className="w-2 h-2 rounded-full bg-background-50 live-dot" />
          <span className="text-xs md:text-sm font-semibold tracking-widest whitespace-nowrap">正在发生</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track whitespace-nowrap">
            {[...tickerNews, ...tickerNews].map((t, i) => (
              <span key={i} className="inline-flex items-center text-xs md:text-sm px-5">
                <i className="ri-flashlight-fill text-primary-400 mr-2" />
                {t}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden md:flex items-center gap-1.5 shrink-0 px-4 border-l border-background-700 text-xs">
          <i className="ri-time-line" />
          <span>2026-09-08</span>
        </div>
      </div>

      {/* nav */}
      <div
        className={`transition-all duration-300 border-b ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-300"
            : "bg-background-100/70 border-background-200"
        }`}
      >
        <div className="mx-auto max-w-7xl px-4 md:px-6 flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-radar-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-lg text-foreground-950 tracking-wide">直击现场</span>
              <span className="text-[10px] text-foreground-500 tracking-[0.28em] mt-0.5">LIVE · 第一现场</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 font-medium rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#report"
              className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-camera-line" />
              立即报料
            </a>
            <button
              aria-label="展开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md hover:bg-background-200 text-foreground-800 text-xl"
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 pb-4 pt-2">
            <nav className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200 rounded-md"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#report"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2.5 text-sm font-semibold"
              >
                <i className="ri-camera-line" />
                立即报料
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}